import { useEffect, useState } from "react";

type OfflineBannerState = {
  isVisible: boolean;
};

function isBrowserOffline() {
  return typeof navigator !== "undefined" && navigator.onLine === false;
}

function useOfflineBanner(): OfflineBannerState {
  const [isVisible, setIsVisible] = useState(isBrowserOffline);

  useEffect(() => {
    const syncOfflineState = () => {
      setIsVisible(isBrowserOffline());
    };

    window.addEventListener("offline", syncOfflineState);
    window.addEventListener("online", syncOfflineState);
    window.addEventListener("focus", syncOfflineState);
    document.addEventListener("visibilitychange", syncOfflineState);

    syncOfflineState();

    return () => {
      window.removeEventListener("offline", syncOfflineState);
      window.removeEventListener("online", syncOfflineState);
      window.removeEventListener("focus", syncOfflineState);
      document.removeEventListener("visibilitychange", syncOfflineState);
    };
  }, []);

  return { isVisible };
}

export { useOfflineBanner };
